<div class="upload-dialog">
    <div class="dialog-header">
      <div>Confirm Delete</div>
      <div class="dialog-text">Are you sure you would like to delete {{formType}}? </div>
    </div>
    <div class="dialog-buttons">
      <button type="button" class="d-form-btn-browse d-form-btn-style d-form-btn-text" (click)="closeAndConfirmDialog()">
        Yes
      </button>
      <button type="button" class="d-form-btn d-form-btn-style d-form-btn-text" (click)="closeAndNotConfirmDialog()">
        Cancel
      </button>
    </div>
  </div>
